import React, {Component} from 'react';
import {
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import {
  alphabeticallySort,
  textContains
} from '../../../shared/utils';
import moment from "moment";

class AccountProgramList extends Component {
  render(){
    const { programs, updateProgram } = this.props;
    return (
      <div>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={programs}
              searchPromptText='Search by name'
              emptyText='This account has no programs'
              columns={[
                {
                  display:'Program Name',
                  name:'name',
                  width:20,
                    sortFunc:(a,b) => alphabeticallySort(a.name,b.name),
                    filterFunc:(a,searchParam) => textContains(a.name,searchParam),
                  renderCell:(item) => (
                      <div>
                          <Link to={`${this.props.match.url}/${item.id}`}>{item.name}</Link>
                      </div>
                  )
                },
                  {
                      name:'status',
                      width:10,
                      renderCell:(item) => (
                          <div>
                              <span>{item.status}</span>
                          </div>
                      )
                  },
                  {
                      name:'startDate',
                      display:'Start Date',
                      width:15,
                      sortFunc:(a,b) => a.startDate - b.startDate,
                      renderCell:(item) => <span>{moment(item.startDate).format('MMM D, YYYY')}</span>
                  },
                  {
                      name:'endDate',
                      display:'End Date',
                      width:15,
                      sortFunc:(a,b) => a.endDate - b.endDate,
                      renderCell:(item) => <span>{moment(item.endDate).format('MMM D, YYYY')}</span>
                  },
                  {
                      name:'displayDate',
                      display:'Display Date',
                      width:15,
                      sortFunc:(a,b) => a.displayDate - b.displayDate,
                      renderCell:(item) => <span>{moment(item.displayDate).format('MMM D, YYYY')}</span>
                  },{
                  width:20,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`${this.props.match.url}/${item.id}`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button>
                        &nbsp;&nbsp;
                        {/*<DropdownButton*/}
                        {/*    options={[*/}
                        {/*        {*/}
                        {/*            text: item.status === 'active' ? 'Deactivate' :'Activate',*/}
                        {/*            onClick: () => updateProgram(item.id, {status: item.status === 'active' ? 'draft' : 'active'}).*/}
                        {/*                then((res) => {*/}
                        {/*                console.log('Update program update result:')*/}
                        {/*                    const err = {"campaigns":"The sum of experiences in this program 10200.00 does not equal the budget amount entered 200.00","endDate":"End date can't be before today"}*/}
                        {/*                     console.log(err)*/}
                        {/*                for (const [key, value] of Object.entries(err)) {*/}
                        {/*                    console.log(key, value);*/}
                        {/*                }*/}
                        {/*                this.setState({error:err})*/}
                        {/*            })*/}
                        {/*                .catch((err) => {*/}
                        {/*                    console.log('Update program update error:')*/}
                        {/*                    console.log(err)*/}
                        {/*                    this.setState({validationMessages:err})*/}
                        {/*                })*/}
                        {/*        }*/}
                        {/*    ]}*/}
                        {/*/>*/}
                    </div>
                  )
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccountProgramList;



// WEBPACK FOOTER //
// ./src/routes/AccountProgramList/components/AccountProgramList.js